import { BusinessTypeEnum } from "~/__generated__/graphql"
import { useCurrentUser } from "~/auth/CurrentUserContext"

// Talent agencies go straight onto the free Roster plan, so onboarding has no
// "Choose Your Plan" step for them (ZAN-893). Invited users have no agency
// until company details are saved, so fall back to the invite-time type.
export const useSkipsPlanStep = () => {
  const { agency, agencyBusinessType } = useCurrentUser()
  return (
    (agency?.businessType ?? agencyBusinessType) === BusinessTypeEnum.Talent
  )
}
